export const bniChapterName = (name: string) => {
  const cleaned = name.trim().replace(/^(?:BNI\s+)+/i, "");
  return cleaned ? `BNI ${cleaned}` : "BNI Chapter";
};

const isChapterNameField = (key: string, parentKey?: string) =>
  key === "chapterName" ||
  key === "chapter_name" ||
  (key === "name" && (parentKey === "chapter" || parentKey === "chapters"));

/** Defensive display-boundary guard for every JSON response used by the UI. */
export const normalizeChapterNames = <T>(value: T, parentKey?: string): T => {
  if (Array.isArray(value)) return value.map((item) => normalizeChapterNames(item, parentKey)) as T;
  if (!value || typeof value !== "object" || value instanceof Date) return value;
  return Object.fromEntries(Object.entries(value as Record<string, unknown>).map(([key, child]) => [
    key,
    typeof child === "string" && isChapterNameField(key, parentKey)
      ? bniChapterName(child)
      : normalizeChapterNames(child, key),
  ])) as T;
};
